import {
    image_processing_endpoint,
    image_processing_status_endpoint,
} from "../../lib/endpoint";
const edgeBaseURL = process.env.REACT_APP_EDGE_BASE_URL;
console.log("edgeBaseURL", edgeBaseURL);
export async function postProccessBulkImages(data) {
    const headers = {
        "Content-Type": "application/json",
    };
    const res = await fetch(edgeBaseURL + image_processing_endpoint, {
        method: "POST",
        headers,
        cache: "no-store",
        body: JSON.stringify(data),
    });
    return await res.json();
}
export async function checkProcessingStatus(processId) {
    const headers = {
        "Content-Type": "application/json",
    };
    const res = await fetch(
        edgeBaseURL + image_processing_status_endpoint + processId,
        {
            method: "GET",
            headers,
            cache: "no-store",
        }
    );
    return await res.json();
}
